import React, { Component } from 'react'
import { compose } from 'recompose'
import { refElements } from './utils/elementUtils'
import { withElement } from './utils/withElement'
import { getRouter } from './utils/withRouter'
import { getAssets } from './utils/withAssets'
import withContextElement from './withContextElement'
import Section from './elements/Section'
import Container from './elements/Container'
import Button from './elements/button/Button'
import Text from './elements/text/Text'
import Columns from './elements/columns/Columns'
import Column from './elements/column/Column'
import Image from './elements/image/Image'
import Div from './elements/Div'
import Divider from './elements/divider/Divider'
import Card from './elements/card/Card'
import CategoryMenus from './elements/categoryMenus/CategoryMenus'
import ImageCarousel from './elements/imageCarousel/ImageCarousel'
import CardGroup from './elements/cardGroup/CardGroup'
import CountDown from './elements/countDown/CountDown'
import ProductCard from './elements/productCard'
import ProductSlider from './elements/productSlider'
import Youtube from './elements/youtube/Youtube'
import TextEditor from './elements/textEditor/TextEditor'

/*eslint-disable */
// input
//  all of element props
//  renderElements
const ContextElementSwitcher = (
  compose(
    withContextElement(),
    getRouter(),
    withElement(),
    getAssets(),
  )
)(
  class extends Component {

    renderElement = () => {
      const { refElement, ...props } = this.props
      switch (refElement) {
        case refElements.SECTION:
          return <Section {...props} />
        case refElements.CONTAINER:
          return <Container {...props} />
        case refElements.BUTTON:
          return <Button {...props} />
        case refElements.TEXT:
          return <Text {...props} />
        case refElements.COLUMNS:
          return <Columns {...props} />
        case refElements.COLUMN:
          return <Column {...props} />
        case refElements.IMAGE:
          return <Image {...props} />
        case refElements.DIV:
          return <Div {...props} />
        case refElements.DIVIDER:
          return <Divider {...props} />
        case refElements.CARD:
          return <Card {...props} />
        case refElements.CATEGORY_MENUS:
          return <CategoryMenus {...props} />
        case refElements.IMAGE_CAROUSEL:
          return <ImageCarousel {...props} />
        case refElements.CARD_GROUP:
          return <CardGroup {...props} />
        case refElements.COUNT_DOWN:
          return <CountDown {...props} />
        case refElements.PRODUCT_CARD:
          return <ProductCard {...props} />
        case refElements.PRODUCT_SLIDER:
          return <ProductSlider {...props} />
        case refElements.YOUTUBE:
          return <Youtube {...props} />
        case refElements.TEXT_EDITOR:
          return <TextEditor {...props} />
        default:
          return <div>Cannot find Element</div>
      }
    }

    render() {
      return (this.renderElement())
    }
  }
)


export default ContextElementSwitcher



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/ContextElementSwitcher.js